import { api } from '@/lib/api';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { FetchAccountIdentitiesParams, FetchAccountIdentitiesResponse } from './types';

const _fetchAccountIdentities = async ({
  accountNumber,
}: FetchAccountIdentitiesParams): Promise<
  AxiosResponse<FetchAccountIdentitiesResponse>
> => {
  return api.get(`identities/listByAccount?account_id=${accountNumber}`);
};

const useFetchAccountIdentities = (
  accountNumber?: FetchAccountIdentitiesParams['accountNumber'],
  enabled?: boolean
) => {
  return useQuery({
    queryKey: ['fetch-account-identities', { accountNumber }],
    queryFn: () => _fetchAccountIdentities({ accountNumber: accountNumber! }),
    enabled: !!accountNumber && (!!enabled || typeof enabled === 'undefined'),
    retry: 0,
  });
};

export { useFetchAccountIdentities };
